import { DateTime } from "luxon"

const days = {
    lunes: 1,
    martes: 2,
    miercoles: 3,
    jueves: 4,
    viernes: 5,
    sabado: 6,
    domingo: 0,
}

export function useTarifasValidation() {
    const validationByDate = (tarifa: any, fecha_inicio: Date | undefined) => {
        const tarifa_fi = DateTime.fromISO(tarifa?.fecha_inicio?.substring(0, 10)).toJSDate().getTime()
        const tarifa_ff = DateTime.fromISO(tarifa?.fecha_final?.substring(0, 10)).toJSDate().getTime()

        const dayList: any[] = Object.keys(tarifa?.dias_disponibles || {})?.map((d) => days?.[d]) || []

        const validDate = fecha_inicio
            ? fecha_inicio?.getTime() >= tarifa_fi && fecha_inicio?.getTime() <= tarifa_ff
            : false

        return validDate && dayList.includes(fecha_inicio?.getDay())
    }

    const validationByDateRange = (tarifa: any, fecha_inicio: Date | undefined, fecha_fin: Date | undefined) => {
        const tarifa_fi = DateTime.fromISO(tarifa?.fecha_inicio?.substring(0, 10)).toJSDate().getTime()
        const tarifa_ff = DateTime.fromISO(tarifa?.fecha_final?.substring(0, 10)).toJSDate().getTime()

        const validDate = fecha_inicio && fecha_fin
            ? tarifa_fi <= fecha_fin?.getTime() && tarifa_ff >= fecha_inicio.getTime()
            : false

        return validDate
    }

    return {
        validationByDate,
        validationByDateRange,
    }
}
